/* eslint-disable no-plusplus */
import { capitalize } from "lodash";

export const getIntervalNumber = (intervals, plans, subscription) => {
  if (subscription) {
    for (let i = 0; i < plans.length; i++) {
      const plan = plans[i];
      if (plan.planId === subscription.planId) {
        for (let j = 0; j < plan.cycles.length; j++) {
          const cycle = plan.cycles[j];
          if (cycle.cycleId === subscription.cycleId) {
            for (let k = 0; k < intervals.length; k++) {
              if (intervals[k] === cycle.pricingModel.frequencyType) {
                return k;
              }
            }
          }
        }
      }
    }
  }
  return 0;
}

export const getPricing = (userType, plans, frequencyType) => {
  let nonePrice = 'FREE';
  let iconCorePrice = 'FREE';
  let iconPlusPrice = 'FREE';
  let iconProPrice = 'FREE';

  if (plans) {
    for (let i = 0; i < plans.length; i++) {
      const plan = plans[i];
      const planNames = plan.name.split(' - ');
      const iPlanType = planNames[0];
      const iPlanName = planNames[1];
      if (iPlanType.startsWith(userType)) {
        let price = 0;
        let formattedPrice;
        let interval;
        for (let j = 0; j < plan.cycles.length; j++) {
          const cycle = plan.cycles[j];
          if (cycle.visibility === 'Public' && cycle.pricingModel.frequencyType === frequencyType) {
            price = cycle.pricingModel.price;
            switch (cycle.pricingModel.frequencyType) {
              case 'Yearly':
                interval = 'year';
                break;
              case 'Weekly':
                interval = 'week';
                break;
              case 'Daily':
                interval = 'day';
                break;
              default:
                interval = 'month';
                break;
            }
            break;
          }
        }
        if (price === 0) {
          formattedPrice = 'FREE'
        } else {
          formattedPrice = `$${price / 100}/${interval}`;
        }
        if (iPlanName === "None") {
          nonePrice = formattedPrice;
        } else if (iPlanName === "ICON Core") {
          iconCorePrice = formattedPrice;
        } else if (iPlanName === "ICON Plus") {
          iconPlusPrice = formattedPrice;
        } else if (iPlanName === "ICON Pro") {
          iconProPrice = formattedPrice;
        }
      }
    }
  }
  return {
    None: nonePrice,
    'ICON Core': iconCorePrice,
    'ICON Plus': iconPlusPrice,
    'ICON Pro': iconProPrice
  };
}

// Features available for each plan
// Features available for each plan
export const features = [
  'Request Tooling Location - Form Submit',
  'Real Time Tooling Search',
  'Solicitation bid matching to capabilities/tooling',
  'Solicitation view full details',
  'Supplier Capability DB entry - enhanced directory listing',
  'Supplier Capability DB Entry - Simple directory listing',
  'Internal Messaging',
  'Procurement History Search',
  'Inventory Management upload/search',
  'Contract Mgmt./Internal RFQs',
  'Basic Technical Support',
  'Frontline Technical Support',
  'ACE Basic Automatic Contract Evaluation',
];

export const planFeatures = {
  New: [],
  None: [
    'Request Tooling Location - Form Submit',
  ],
  'ICON Core': [
    'Request Tooling Location - Form Submit',
    'Solicitation bid matching to capabilities/tooling',
    'Supplier Capability DB Entry - Simple directory listing',
    'Basic Technical Support',
  ],
  'ICON Plus': [
    'Request Tooling Location - Form Submit',
    'Real Time Tooling Search',
    'Solicitation bid matching to capabilities/tooling',
    'Solicitation view full details',
    'Supplier Capability DB entry - enhanced directory listing',
    'Supplier Capability DB Entry - Simple directory listing',
    'Internal Messaging',
    'Procurement History Search',
    'Inventory Management upload/search',
    'Contract Mgmt./Internal RFQs',
    'Basic Technical Support',
    'Frontline Technical Support',
  ],
  'ICON Pro': [
    'Request Tooling Location - Form Submit',
    'Real Time Tooling Search',
    'Solicitation bid matching to capabilities/tooling',
    'Solicitation view full details',
    'Supplier Capability DB entry - enhanced directory listing',
    'Supplier Capability DB Entry - Simple directory listing',
    'Internal Messaging',
    'Procurement History Search',
    'Inventory Management upload/search',
    'Contract Mgmt./Internal RFQs',
    'Basic Technical Support',
    'Frontline Technical Support',
    'ACE Basic Automatic Contract Evaluation',
  ]
};

export const valuePlan = plan => ['New', 'None', 'ICON Core', 'ICON Plus', 'ICON Pro'].indexOf(plan);

export const comparePlans = (planA, planB) => valuePlan(planA) - valuePlan(planB);

export const gainPlan = (planA, planB) => {
  const featuresA = planFeatures[planA];
  const featuresB = planFeatures[planB];
  const gained = [];
  featuresB.forEach(item => {
    if (!featuresA.includes(item)) {
      gained.push(item);
    }
  })
  return gained;
}

export const losePlan = (planA, planB) => {
  const featuresA = planFeatures[planA];
  const featuresB = planFeatures[planB];
  const lost = [];
  featuresA.forEach(item => {
    if (!featuresB.includes(item)) {
      lost.push(item);
    }
  })
  return lost;
}

// Get plan details from billsby:
export const getPlanDetails = (userType, planName, plans, frequencyType) => {
  let planId = 0;
  let cycleId = 0;
  let freeTrial = 0;
  let freeTrialFrequencyType = ''
  if (plans) {
    for (let i = 0; i < plans.length; i++) {
      const plan = plans[i];
      const planNames = plan.name.split(' - ');
      const iPlanType = planNames[0];
      const iPlanName = planNames[1];
      if (iPlanName === planName && iPlanType.startsWith(userType)) {
        planId = plan.planId;
        for (let j = 0; j < plan.cycles.length; j++) {
          const cycle = plan.cycles[j];
          if (cycle.visibility === 'Public' && cycle.pricingModel.frequencyType === frequencyType) {
            cycleId = cycle.cycleId;
            freeTrial = cycle.pricingModel.freeTrial;
            freeTrialFrequencyType = cycle.pricingModel.freeTrialFrequencyType;
            break;
          }
        }
        break;
      }
    }
  }

  // Override trial period for ICON Pro plan to 2 weeks
  if (planName === 'ICON Pro') {
    freeTrial = 2;
    freeTrialFrequencyType = 'Weekly';
  }

  let freeTrialPeriod = '';
  if (freeTrial) {
    freeTrialPeriod = freeTrial.toString();

    let unit = '';
    switch (freeTrialFrequencyType) {
      case 'Yearly':
        unit = 'year';
        break;
      case 'Weekly':
        unit = 'week';
        break;
      case 'Daily':
        unit = 'day';
        break;
      default:
        unit = 'month';
        break;
    }

    if (freeTrial > 1) {
      unit += 's';
    }
    freeTrialPeriod += ` ${unit}`;
  }

  return {
    name: planName,
    features: planFeatures[planName],
    planId,
    cycleId,
    freeTrialPeriod,
  };
}

export const getPlanName = (planId, plans) => {
  for (let i = 0; i < plans.length; i++) {
    const plan = plans[i];
    if (plan.planId === planId) {
      return plan.name;
    }
  }
  return '';
}

export const getCardTypeName = (cardType) => {
  const names = cardType.split('_');
  let cardTypeName = capitalize(names[0]);
  for (let i = 1; i < names.length; i++) {
    cardTypeName += ` ${capitalize(names[i])}`;
  }
  return cardTypeName;
}

// Return price associated with planId:
export const getPrice = (planId, cycleId, plans) => {
  let price = 0;
  for (let i = 0; i < plans.length; i++) {
    const plan = plans[i];
    if (plan.planId === planId) {
      for (let j = 0; j < plan.cycles.length; j++) {
        const cycle = plan.cycles[j];
        if (cycle.cycleId === cycleId) {
          price = cycle.pricingModel.price;
          break;
        }
      }
      break;
    }
  }
  return price;
}

// Use alternate cycleId for planData:
export const altPlanData = (planData, plans) => {
  for (let i = 0; i < plans.length; i++) {
    if (plans[i].planId === planData.planId) {
      for (let j = 0; j < plans[i].cycles.length; j++) {
        const cycle = plans[i].cycles[j];
        if (cycle.cycleId !== planData.cycleId &&
          cycle.visibility === 'Public' &&
          cycle.frequenceType === planData.frequencyType) {
          return { ...planData, cycleId: cycle.cycleId };
        }
      }
      return planData;
    }
  }
  return planData;
}

export const getUserType = (industryAssociations) => {
  let isAssociated = false;

  for (let i = 0; i < industryAssociations.length; i++) {
    if (industryAssociations[i].indexOf('*') < 0) {
      isAssociated = true;
    }
  }
  return isAssociated ? 'Members' : 'Non-Members';
}

export const getUserTypeA = (associationValidations) => {
  let isAssociated = false;

  if (associationValidations && associationValidations.length) {
    for (let i = 0; i < associationValidations.length; i++) {
      // Explicitly ignore "None" entries - they should be treated as Public
      if (associationValidations[i].name !== 'None' &&
        (associationValidations[i].status === 'current' ||
          associationValidations[i].status === 'inheriting' ||
          associationValidations[i].status === 'grace_period')
      ) {
        isAssociated = true;
        break;
      }
    }
  }
  return isAssociated ? 'Members' : 'Non-Members';
}

export const displayAssociations = (associationValidations, sep = ', ') => {
  let result = '';
  if (associationValidations) {
    for (let i = 0; i < associationValidations.length; i++) {
      if (result !== '') {
        result += sep;
      }
      let annotation = '';
      let status = associationValidations[i].status;
      if (!status) {
        status = 'unknown'
      } else {
        status = status.replace('_', '-');
      }
      if (status === 'none' || status === 'unknown') {
        annotation = 'not validated'
      } else if (status !== 'current') {
        annotation = status;
      }
      if (annotation) {
        annotation = ` (${annotation})`
      }
      result += associationValidations[i].name + annotation;
    }
  }
  if (!result) {
    result = 'None';
  }
  return result;
}

export const isValidated = (associationValidations) => {
  let isAssociated = null;

  if (associationValidations && associationValidations.length > 0) {
    for (let i = 0; i < associationValidations.length; i++) {
      // Explicitly ignore "None" entries - they should never be considered validated
      if (associationValidations[i].name !== 'None' &&
        (associationValidations[i].status === 'current' ||
          associationValidations[i].status === 'inheriting' ||
          associationValidations[i].status === 'grace_period')
      ) {
        isAssociated = associationValidations[i].name;
        break;
      }
    }
  }
  return isAssociated;
}

export const compareAssoc = (newAssociationValidations, oldAssociationValidations) => {
  const newValid = isValidated(newAssociationValidations);
  const oldValid = isValidated(oldAssociationValidations);
  if (newValid && !oldValid) {
    return [1, newValid]
  }
  if (!newValid && oldValid) {
    return [-1, oldValid]
  }
  return [0, ''];
}

export default {
  getPricing,
  features,
  planFeatures,
  getPlanDetails,
  getUserType,
};



// WEBPACK FOOTER //
// ./src/components/Billsby/plans.js